import DestinationsMobile from "./DestinationsMobile";

export default DestinationsMobile;
